module.exports = __webpack_public_path__ + "img/photo-6-1.fe8b6b5c.jpg";